import { getLatestObjectByTimestamp, getObjectByKeyValue } from '@/helpers/common/helper'

export const getLatestStudyState = (latestDeviceStudy) => {
  return getLatestObjectByTimestamp(latestDeviceStudy?.states, 'timestamp')
}

export const getStudyStateById = (latestDeviceStudy, stateId) => {
  return getObjectByKeyValue(latestDeviceStudy?.states, "id", stateId)
}
